import { render, staticRenderFns } from "./cancelShippingModalContent.vue?vue&type=template&id=2c690268&scoped=true"
import script from "./cancelShippingModalContent.vue?vue&type=script&lang=js"
export * from "./cancelShippingModalContent.vue?vue&type=script&lang=js"
import style0 from "./cancelShippingModalContent.vue?vue&type=style&index=0&id=2c690268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c690268",
  null
  
)

export default component.exports